import { animate, state, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as constants from 'src/constant.json';
import { ClientDashboardService } from '../../service/client-dashboard.service';
import { ClientDashboardState } from '../../state/client-dashboard.state';

@Component({
  selector: 'app-agent-analytics',
  templateUrl: './agent-analytics.component.html',
  styleUrls: ['./agent-analytics.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class AgentAnalyticsComponent implements OnInit, AfterViewInit {
  dataSource: MatTableDataSource<any>;
  agentTableColumnList: Array<string> = [
    'name',
    'pendingCount',
    'activeCount',
    'recentListingCount',
    'previousListingCount',
    'recentCancelledCount',
    'previousCancelledCount',
    'recentSoldCount',
    'previousSoldCount',
    'recentBuyCount',
    'previousBuyCount',
    'recentAvgListPrice',
    'previousAvgListPrice',
    'recentAvgClosePrice',
    'previousAvgClosePrice',
    'recentSfrCount',
    'previousSfrCount',
    'recentThCount',
    'previousThCount',
    'recentCondoCount',
    'previousCondoCount',
  ];
  activeCol = 'recent';
  isDataLoading: boolean;
  constant: any = constants;
  filterForm: FormGroup;
  selectedState: string;
  fips: number;
  expandedElement;
  onDestroyNotifier$ = new Subject();

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private formBuilder: FormBuilder,
    private clientService: ClientDashboardService,
    public clientState: ClientDashboardState
  ) {}

  ngOnInit() {
    this.filterForm = this.formBuilder.group({
      state: null,
      fips: null,
    });
  }

  ngAfterViewInit() {
    this.filterResult();
  }

  filterResult(state?, fips?) {
    let params: any = {};
    this.paginator.pageSize && (params.limit = this.paginator.pageSize);
    this.paginator.pageIndex && (params.offset = this.paginator.pageIndex * this.paginator.pageSize);
    state && (params.state = state);
    fips && (params.fips = fips);
    this.clientService
      .fetchAgentAnalytics(params)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe(({ isLoading }) => {
        this.isDataLoading = isLoading;
      });
  }
  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }
}
